import React from 'react';
import {Button, Grid, Header, Icon, Loader, Popup, Responsive, Segment, Tab, Table} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';

import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import { ExportReactCSV } from '../../util/ExportCSV';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";
import { IconHeader } from '../ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p><FormattedMessage id="professorStatistics.noStudents" /></p>;
const NoData = () => <p><FormattedMessage id="professorStatistics.noCourses" /></p>;

export default class CourseDetails extends React.Component {
    constructor(props) {
        super(props);

        let storedCourseImplementationId = '';
        let storedCourseImplementationName = '';

        if (localStorage.getItem('courseImplementationId')) {
            storedCourseImplementationId = parseInt(localStorage.getItem('courseImplementationId'), 10);
        }

        if (localStorage.getItem('courseImplementationName')) {
            storedCourseImplementationName = parseInt(localStorage.getItem('courseImplementationName'), 10);
        }

        this.state = {
            data: [],
            courseDetails: [],
            courseImplementationId: storedCourseImplementationId,
            courseImplementationName: storedCourseImplementationName,

            loading: true,
            activeIndex: 0,

            isLoading: false,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCourseDetails = this.getCourseDetails.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.courseBasicId) {
            const { courseBasicId, courseBasicName } = this.props.location.state;
            localStorage.setItem('courseBasicIdForDetails', courseBasicId);
            localStorage.setItem('courseImplementationName', courseBasicName);
            this.getCourseBasicDetails(courseBasicId);
        } else if (this.props.location.state) {
            localStorage.setItem('courseImplementationId', this.props.location.state.courseImplementationId);
            localStorage.setItem('courseImplementationName', this.props.location.state.courseImplementationName);
            this.getCourseDetails(this.props.location.state.courseImplementationId);
        } else if (window.location.pathname === '/predmeti/detalji') {
            this.getCourseBasicDetails(parseInt(localStorage.getItem('courseBasicIdForDetails'), 10));
        } else {
            this.getCourseDetails(parseInt(localStorage.getItem('courseImplementationId'), 10));
        }
    }

    getCourseBasicDetails(courseBasicId) {
        const activeRole = localStorage.getItem('activeRole');
        const organizationalUnitId = localStorage.getItem('orgUnitId');
        const url = activeRole === 'Administrator' || activeRole === 'AIDA'
            || activeRole === 'Support'
            || activeRole.substr(0, 38) === 'Služba za nastavu i studentska pitanja'
            || activeRole.substr(0, 30) === 'Služba za osiguranje kvaliteta'
            ? `/course/csp-info/by-course-basic/${courseBasicId}/${organizationalUnitId}`
            : `/course/csp-info/by-course-basic/${courseBasicId}/`;

        axios.get(url)
            .then(res => this.setState({ courseDetails: res.data, loading: false }))
            .catch(() => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch course details');
            });
    }

    getCourseDetails(courseImplementationId) {
        axios.get((localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja'))  ? `/course/csp-info/${courseImplementationId}/${localStorage.getItem('orgUnit')}`
            : `/course/csp-info/${courseImplementationId}/`)
            .then(res => {
                const courseDetails = res.data;
                this.setState({ courseDetails, loading: false});
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch course details');
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        const headersForExport = [
            { label: 'Prezime', key: 'lastName' },
            { label: 'Ime', key: 'firstName' },
            { label: 'Index', key: 'index' },
            { label: 'Studijski program', key: 'studyProgram' },
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);
        const courseDetailGroups = this.state.courseDetails.reduce((groups, courseDetail) => {
            const groupKey = courseDetail.studyProgramId || `${courseDetail.studyProgramBasicName}-${courseDetail.studyProgramName}`;
            const existingGroup = groups.find(group => group.key === groupKey);
            if (existingGroup) {
                existingGroup.rows.push(courseDetail);
            } else {
                groups.push({ key: groupKey, rows: [courseDetail] });
            }
            return groups;
        }, []);

        return (
            <div>
                <Header as="h1"><FormattedMessage id="common.details" /></Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                {localStorage.getItem('courseImplementationName')}
                                <Header.Subheader floated="left">
                                    {(localStorage.getItem('courseComment')) === 'null' ? <FormattedMessage id="common.course" /> : localStorage.getItem('courseComment')}
                                </Header.Subheader>
                                {/* <Header.Subheader> <FormattedMessage id="common.course" /></Header.Subheader> */}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                               <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>


                        </Header>
                    </Segment>

                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                        <Segment>
                            <div>


                                {this.state.courseDetails.length ? <Table celled selectable compact style={{ borderCollapse: 'collapse' }}>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell colSpan={2}>
                                                    <Header>
                                                        <Header.Content>
                                                            <FormattedMessage id="common.studyProgram" />
                                                            <Header.Subheader><FormattedMessage id="professorStatistics.studyProgramCourse" /></Header.Subheader>
                                                        </Header.Content>

                                                    </Header>
                                                </Table.HeaderCell>

                                                <Table.HeaderCell width="2">Semestar</Table.HeaderCell>
                                                <Table.HeaderCell width="3"><FormattedMessage id="common.courseCode" /></Table.HeaderCell>
                                                <Table.HeaderCell width="1">
                                                    ECTS
                                                </Table.HeaderCell>
                                                <Table.HeaderCell width="2" >
                                                    <FormattedMessage id="common.lectureExerciseSeminarAbr" />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell width="2"><FormattedMessage id="common.courseType" /></Table.HeaderCell>

                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body> {courseDetailGroups.map(group => group.rows.map((el, rowIndex) =>
                                            (<Table.Row key={`${el.id}-${el.semesterNameKey || rowIndex}`} >
                                                    {rowIndex === 0 && <Table.Cell
                                                        verticalAlign="middle"
                                                        colSpan={2}
                                                        rowSpan={group.rows.length}
                                                        style={{
                                                            borderRight: '1px solid rgba(34, 36, 38, 0.15)',
                                                            boxShadow: '1px 0 0 rgba(34, 36, 38, 0.08)'
                                                        }}
                                                    >
                                                        <Grid columns={1} centered className="stackable">
                                                            <Grid.Row verticalAlign="middle">
                                                                <Grid.Column width="10">
                                                                    <strong>{el.studyProgramBasicName ==='-' ? el.departments[0].name : el.studyProgramBasicName}</strong>
                                                                    { ' | ' + el.studyProgramName }
                                                                </Grid.Column>
                                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                                    <span style={{ color: '#a6a4a1' }}>{el.studyCycles[0].name}</span>
                                                                </Grid.Column>
                                                            </Grid.Row>
                                                        </Grid>
                                                        {/*<strong>{el.studyProgramBasicName ==='-' ? el.departments[0].name : el.studyProgramBasicName}</strong>*/}
                                                        {/*{ ' | ' + el.studyProgramName }*/}
                                                    </Table.Cell>}

                                                    <Table.Cell verticalAlign="middle">
                                                        {el.semesterNameKey || '-'}
                                                    </Table.Cell>

                                                    <Table.Cell verticalAlign="middle" >
                                                        {el.code}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" >
                                                        {el.ects}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" >
                                                        {el.lectureNumber ? el.lectureNumber : '0'} + {el.exerciseNumber ? el.exerciseNumber : '0'} + {el.seminarNumber ? el.seminarNumber : '0'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" >
                                                        {el.mandatory ? <FormattedMessage id="common.mandatory" />
                                                            : <FormattedMessage id="common.optional" />}
                                                    </Table.Cell>

                                                </Table.Row>
                                            ))) }
                                        </Table.Body>
                                    </Table>
                                    : <NoData />
                                }

                            </div>
                        </Segment>
                    }

                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/Courses/CourseDetails.js